<div class="p-5">
  <div class="d-flex justify-content-center align-items-center my-2">
    <div class=" text-center">
      <div class="card-sub-heading bold font_custom mb-3">Are you sure to cancel?</div>
    </div>
  </div>
  <div class=" d-flex mt-4">
    <div class="col-md-12 d-flex justify-content-center ">
      <button class="custom-btn w-100" type="button" (click)="this.dialogRef.close();">No</button>
      <button class="custom-btn w-100" type="button" (click)="yesSubmit()" >Yes</button>
    </div>
  </div>
</div>
  